/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Forward_One_FrameInputs */



/**
* | output |
* | --- |
* | "Go forward one frame in the video" |
*
* @param {Shortcut_Keys_Desc_Forward_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_forward_one_frame = /** @type {((inputs?: Shortcut_Keys_Desc_Forward_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Forward_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer d'une image dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Video ein Bild vorwärts springen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai avanti di un fotogramma nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотайте видео на один кадр вперед.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar un fotograma en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频快进一帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを1フレーム進める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में एक फ्रेम आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avance um quadro no vídeo.")
	return /** @type {LocalizedString} */ ("Go forward one frame in the video")
});